export const createNElements = (n = 3) => {
  return Array.from(Array(n).keys());
};
